import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled, { css } from 'styled-components';
import { getColor, getRadii } from '@yoweb/ui/styles/utils/theme';
import { minHeightMixin } from '@yoweb/ui/styles/utils/mixins.utils';
import { media } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var ActionModalContainer = function ActionModalContainer(_ref) {
  var children = _ref.children,
      minHeight = _ref.minHeight,
      fullScreenMobile = _ref.fullScreenMobile;
  return /*#__PURE__*/_jsx(ModalContainer, {
    minHeight: minHeight,
    fullScreenMobile: fullScreenMobile,
    children: children
  });
};
var ModalContainer = styled.div.withConfig({
  componentId: "sc-ysi7ve-0"
})(["background:", ";border-radius:", ";display:flex;flex-direction:column;max-height:100vh;max-height:-webkit-fill-available;max-height:fill-available;", ";", ""], getColor('base000'), getRadii('large'), minHeightMixin, function (_ref2) {
  var fullScreenMobile = _ref2.fullScreenMobile;
  return fullScreenMobile && css(["border-radius:0;height:100vh;height:-webkit-fill-available;height:fill-available;", ""], media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        height: auto;\n      "])), getRadii('large')));
});